import { render, staticRenderFns } from "./FasesIndicator.vue?vue&type=template&id=4861e490&scoped=true&"
import script from "./FasesIndicator.vue?vue&type=script&lang=js&"
export * from "./FasesIndicator.vue?vue&type=script&lang=js&"
import style0 from "./FasesIndicator.vue?vue&type=style&index=0&id=4861e490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861e490",
  null
  
)

export default component.exports